import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Text, Flex, Box, VStack } from '@chakra-ui/react';
import getLink, {
  getCollectionLink,
} from '@rsc/utils/getLink';
import Link from '@rsc/ui-components/tailwind/Link';

import { motion } from 'framer-motion';
import SanityBackgroundImage from '../../../atoms/SanityBackgroundImage';

function KeyCollectionsItem({ _key, cta, collectionReference, media, title }) {
  const [hovered, setHovered] = useState(false);
  return (
    <Box w="12rem" key={_key} aspectRatio={1}>
      <VStack
        w="full"
        h="full"
        key={_key}
        as={Link}
        link={
          getLink(cta?.linkType, cta?.href, cta?.internalLink) ||
          getCollectionLink(collectionReference?.store?.title)
        }
        pos="relative"
        flexDirection="column"
        alignItems="flex-start"
        onMouseEnter={() => setHovered(!hovered)}
        onMouseLeave={() => setHovered(!hovered)}
      >
        <SanityBackgroundImage
          gradientGenerator={url =>
            `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 1) 100%), url(${url}), lightgray -155.145px -1.208px / 194.193% 129.866% no-repeat;`
          }
          image={media?.image}
          position="absolute"
          borderRadius="lg"
          width="100%"
          height="100%"
          flexDirection="column"
          as={Flex}
          p={4}
          justifyContent="flex-end"
          maxImageWidth={600}
        >
          <Text
            textStyle="bodyLarge"
            color="typography.lighter"
            fontWeight="semibold"
          >
            {title || collectionReference?.store?.title?.split('/').at(-1)}
          </Text>
          <Box width="100%">
            <motion.div
              variants={{
                hover: { width: '100%' },
                noHover: { width: 0 },
              }}
              initial="noHover"
              animate={hovered ? 'hover' : 'noHover'}
              style={{ height: '2px', background: '#FFEB00' }}
            />
          </Box>
        </SanityBackgroundImage>
      </VStack>
    </Box>
  );
}

KeyCollectionsItem.propTypes = {
  _key: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  cta: PropTypes.shape({
    linkType: PropTypes.string,
    href: PropTypes.string,
    internalLink: PropTypes.shape({
      slug: PropTypes.shape({
        current: PropTypes.string,
      }),
    }),
  }).isRequired,
  media: PropTypes.shape({
    image: PropTypes.shape({
      asset: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
      alt: PropTypes.string,
    }),
  }).isRequired,
  collectionReference: PropTypes.shape({
    store: PropTypes.shape({
      title: PropTypes.string,
    }),
    slug: PropTypes.shape({
      current: PropTypes.string,
    }),
  }).isRequired,
};

export default KeyCollectionsItem;
